import React, { useState } from 'react';
import PropTypes from 'prop-types';

const FacetSection = ({ title, defaultExpanded = true, children }) => {
	const [isExpanded, setIsExpanded] = useState(defaultExpanded);

	const toggleExpanded = () => setIsExpanded((prev) => !prev);

	return (
		<div className="border-bottom">
			<button
				className="btn btn-link shadow-none d-flex align-items-center justify-content-between w-100 py-3 px-0 text-decoration-none text-body"
				onClick={toggleExpanded}
				aria-expanded={isExpanded}
				type="button"
			>
				<span className="font-weight-bold">{title}</span>
				<span
					className="facet-toggle-icon d-flex align-items-center justify-content-center rounded-circle border border-primary text-primary"
					aria-hidden="true"
				>
					<i
						data-testid="expand-icon"
						className={`ddc-icon ${
							isExpanded ? 'ddc-icon-collapse' : 'ddc-icon-expand'
						}`}
					/>
				</span>
			</button>
			{isExpanded && <div className="pt-4 pb-4">{children}</div>}
		</div>
	);
};

FacetSection.propTypes = {
	title: PropTypes.string.isRequired,
	defaultExpanded: PropTypes.bool,
	children: PropTypes.node.isRequired
};

export default FacetSection;
